import { SortData } from '../models/sort.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { UserInfoData } from '../models/api/user-info.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private usersUrl = environment.baseUrl + environment.api + 'users';
  private fleetTranslationsUrl =
    environment.baseUrl + environment.api + 'fleets/translations';
  private vehiclesFilterUrl =
    environment.baseUrl + environment.api + 'users/vehicles_filter_newer';
  // private vehiclesSortUrl = environment.baseUrl +  environment.api + 'users/vehicles_sort';
  private displaySettingsUrl =
    environment.baseUrl + environment.api + 'users/display_settings';
  private vehiclesView: BehaviorSubject<string> = new BehaviorSubject(
    localStorage.getItem('vehiclesView') || 'grid'
  );

  loadFleetTranslations(): Observable<any> {
    return this.http
      .get<{ [key: string]: string }>(this.fleetTranslationsUrl, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((translations) => {
          const result = {};
          for (const i in translations) {
            if (Object.prototype.hasOwnProperty.call(translations, i)) {
              const keys = i.split('.');
              keys.reduce(function (r, e, j) {
                return (
                  r[e] ||
                  (r[e] = isNaN(Number(keys[j + 1]))
                    ? keys.length - 1 === j
                      ? translations[i]
                      : {}
                    : [])
                );
              }, result);
            }
          }
          return result;
        })
      );
  }

  constructor(private http: HttpClient, private authService: AuthService) {}

  getVehiclesFilter(): Observable<any> {
    if (this.authService.isDSLocateUser()) {
      return of(JSON.parse(localStorage.getItem('filterState') || '{}'));
    } else {
      return this.http.get(this.vehiclesFilterUrl, {
        headers: this.authService.getJwtAuthHeaders(),
      });
    }
  }

  // getVehiclesSort(): Observable<SortData> {
  //   if (this.authService.isDSLocateUser()) {
  //     return of(JSON.parse(localStorage.getItem('sortState') || '{}'));
  //   } else {
  //     return this.http.get(this.vehiclesSortUrl, {
  //       headers: this.authService.getJwtAuthHeaders(),
  //     });
  //   }
  // }

  getDisplaySettings(): Observable<any> {
    return this.http.get(this.displaySettingsUrl, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  getUserInfo(): Observable<UserInfoData> {
    return this.http
      .get(this.usersUrl + '/information', {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(map((response) => response as UserInfoData));
  }

  setVehiclesView(vehiclesView) {
    this.vehiclesView.next(vehiclesView);
    localStorage.setItem('vehiclesView', vehiclesView);
  }

  getVehiclesView(): BehaviorSubject<string> {
    return this.vehiclesView;
  }

  saveEmail(email: string) {
    return this.http
      .patch(
        this.usersUrl + 'email',
        { email: email },
        { headers: this.authService.getJwtAuthHeaders() }
      )
      .pipe(map((response) => response as UserInfoData));
  }
}
